import React from 'react';
import { connect } from 'react-redux';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import {FormWithCancelButton} from '../../../../forms/FormWithCancelButton';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupBody from '../../../../components/Popup/PopupBody';
import QrCodeView from '../../QrCodeView/QrCodeView';

class QrCodePopupForTestMode extends FormWithCancelButton {

    componentDidMount() {
        window.addEventListener('HIDE_QR_CODE_POPUP', this.cancel, false);
    }

    componentWillUnmount() {
        window.removeEventListener('HIDE_QR_CODE_POPUP', this.cancel, false);
    }

    render() {
        return (
            <PopupWrapper className="qr-code-popup">
                <PopupHeader title="Scan QR-code" onCancel={this.cancel} />
                <PopupBody>
                    <QrCodeView text={this.props.qrCodeString} />
                </PopupBody>
            </PopupWrapper>
        );
    }
}

function mapStateToProps({ testMode }) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(QrCodePopupForTestMode));